import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Podcastlisting(porps) {
  return (
    <div className="podcast_listing tekrevol_gray_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
            <div className="example" data-text="Podcast Ep">
              <h2>Latest Episodes</h2>
            </div>
            <p>
              We collaborate with entrepreneurs and industry leaders to
              emphasize the importance of digital transformation. We regularly
              invite technopreneurs and change leaders to talk about how
              technology played a crucial role in transforming their businesses
              and how it helps them scale up with sustainability.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Innovating for a Greener Future | Federico Marques</h5>
              <div className="podcast_txt">
                <p>
                  Things are only warming up in the new season of Technology for
                  a Change. For our latest episode, we invited Federico Marques,
                  founder and CEO of Moonflower Farms...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season4-ep2"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Unpacking The Blockchain Revolution | Amalia Grochal</h5>
              <div className="podcast_txt">
                <p>
                  To kick off the new season of Technology for a Change, we
                  invited Amalia Irena Grochal, one of the pioneers in fintech
                  in the Middle East...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season4-ep1"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                The season finale of our podcast "Technology for a Change" is
                live now.
              </h5>
              <div className="podcast_txt">
                <p>Tune in to see everything that went on this season</p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep10"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Mr. Jeetu Kataria, the Co-Founder, and CEO</h5>
              <div className="podcast_txt">
                <p>
                  Mr. Jeetu Kataria shared some interesting insights with our
                  host, Mr. Hady Shaikh, about the DIFX trading platform, the
                  future of your Bitcoin, patent and licensing struggles in...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep9"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Our Flagship Podcast with Mr. Jeremy Thomas</h5>
              <div className="podcast_txt">
                <p>
                  Mr. Jeremy Thomas, the Founder and CEO of Astral Tech has an
                  interesting take on how technology and digital enablement can
                  help the energy and utility sectors enhance operationa...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep8"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>AI in Digital Media with Kate Bradley Chernis</h5>
              <div className="podcast_txt">
                <p>
                  In the seventh episode of our podcast series, "Technology for
                  a Change," our host and Principal Product Strategist, Mr. Hady
                  Shaikh, has invited Ms. Kate Bradley Chernis, an AI-...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep7"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>How to make Self-Believe your Superpower!</h5>
              <div className="podcast_txt">
                <p>
                  Technology for a Change is back with its new episode of Season
                  3!. This time our host and Principal Product Strategist, Hady
                  Shaikh, has invited Ms. Aaliya Rajah, a personal and...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep6"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Small Businesses, Big Wins!</h5>
              <div className="podcast_txt">
                <p>
                  In the 5th episode of #TechnologyForAChange, our Co-founder
                  and CMO, Abeer Raza, sits down with Jeremy Harbour, Founder of
                  Unity Group and Harbour Club...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep5"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>8 Valuable Lessons from Joseph Landes</h5>
              <div className="podcast_txt">
                <p>
                  In the fourth episode of “Technology for a Change,” Season 3,
                  Hady Shaikh, the Principal Product Strategist at TekRevol,
                  interviewed Joseph Landes, the Chief Revenue Officer and Chief
                  Evangelist of Nerdio...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep4"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                Learn How Digital Transformation is the Next Big Thing in the
                GCC
              </h5>
              <div className="podcast_txt">
                <p>
                  Listen to the discussion on technological affairs in the GCC
                  in our latest podcast release...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep3"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                Cyberpsychologist Dr. Michael Nuccitelli Shares Ipredators
                Vision
              </h5>
              <div className="podcast_txt">
                <p>
                  In our latest Technology for a Change episode, Season 3,
                  TekRevol’s Principal Product Strategist...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep2"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Discussing Tech In Dubai & GCC</h5>
              <div className="podcast_txt">
                <p>
                  In the latest episode of Technology for a Change, Season 3,
                  TekRevol’s Principal Product Strategist, Hady Shaikh,
                  interviewed Yalla!Market’s founder, Leo Dovbenko....
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season3-ep1"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Featuring Rajat Mishra Co-Founder of Prezentium</h5>
              <div className="podcast_txt">
                <p>
                  S02 E06 of Technology For Change - featuring Co-Founder of
                  Prezentium, Rajat Mishra as we talk about....
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season2-ep6"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                An Angel Investor the Founder of Uniqorn Incubator and Startup
                Super Cup
              </h5>
              <div className="podcast_txt">
                <p>
                  On S02 E05, we've invited Dom Einhorn, the Founder of Uniqorn
                  Incubator and Startup Super Cup.On S02 E05, we've invited Dom
                  Einhorn, the Founder of Uniqorn Incubator and Startup Super
                  Cup...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season2-ep5"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Tim Kalinowski, Founder, and CEO of LORE</h5>
              <div className="podcast_txt">
                <p>
                  Helping your business/product transform into a brand through
                  communication, Tekrevol partners with Tim Kalinowski, Founder,
                  and CEO of LORE....
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season2-ep4"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Mr. Tyrone Johnson</h5>
              <div className="podcast_txt">
                <p>
                  Engineering is one of the brightest educational fields that
                  have a real-world physical impact on the lives of people...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season2-ep3"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Mr. Hani Masgidi, Founder of Info Media Consultancy</h5>
              <div className="podcast_txt">
                <p>
                  Discussing the topic “From necessity to global standards, how
                  digital technology is reshaping businesses in the MENA
                  region”...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season2-ep2"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>Managing Partner of Tekrevol Daniel Burgess</h5>
              <div className="podcast_txt">
                <p>
                  In Season 2 Episode#1 of Technology For Change, Managing
                  Partner of Tekrevol Daniel Burgess discusses the role of
                  technology...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season2-ep1"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                How Can Technology Implementations Improve Educational
                Institution Processes?
              </h5>
              <div className="podcast_txt">
                <p>
                  Tekrevol's Managing Partner Daniel Burgess is joined by
                  Lillian Row, a Baltimore County Board of Education member...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep8"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                What Does Automation Mean for a Business in The 21st century?
              </h5>
              <div className="podcast_txt">
                <p>
                  In Episode 7, Tekrevol’s Co-Founder and CMO Abeer Raza is
                  joined by the Co-Founder of Remote New Media and Code
                  Assembly, Mr.Paul McGillivray...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep7"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>How To Get Investors To Say “YES” To Your Startup!</h5>
              <div className="podcast_txt">
                <p>
                  In episode #06, we are joined by the founder of Slidebean,
                  Jose Caya, to discuss the importance of pitch decks to
                  increase market excitement about your product...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep6"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>The Importance of Patents in Entrepreneurship</h5>
              <div className="podcast_txt">
                <p>
                  In Episode 5, Abeer Raza sits with the president of American
                  Patent Agency PC, Mr. Daniar Hussain, and Mr.Stephen Hou, a
                  Patent Prosecution Advisor at APA PC...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep5"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                What Makes A Successful Entrepreneur From The Lens Of A Coach
              </h5>
              <div className="podcast_txt">
                <p>
                  In episode #04, Tekrevol Co-Founder Abeer Raza sits with
                  Michelle Law, a business consultant with over a decade of
                  experience of coaching entrepreneurs...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep4"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                The story of Guardian Angel – A lesson in saving lives using a
                mobile app for entrepreneurs
              </h5>
              <div className="podcast_txt">
                <p>
                  In Episode #03 our host was Mr. JR Ridge, actor, producer, and
                  the entrepreneur who founded Guardian Angel discusses the
                  hardship of starting a business from scratch with no
                  investment...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep3"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                How Businesses Are Using Technology To Evolve During Covid-19
                and The Role of Tech In The Future of Entrepreneurship
              </h5>
              <div className="podcast_txt">
                <p>
                  In Episode #02, Mr. Gene Deems, the eGov and services manager
                  from the department of natural resources joined us who
                  discusses the evolution of technology...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep2"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="podcast_list">
              <h5>
                How Steve Built A Successful Business While Saving Lives Through
                The Veteran App
              </h5>
              <div className="podcast_txt">
                <p>
                  In episode #01, we sat with the founder of “The Veteran App”
                  to discuss the role of technology in saving lives and creating
                  positive impact in the world...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep1"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Podcastlisting;
